// removed by extract-text-webpack-plugin
module.exports = {"Profile":"Profile__Profile___3FkOS","ProfileActive":"Profile__ProfileActive___ISqxc","ProfileHidden":"Profile__ProfileHidden___1G55t","profileBox":"Profile__profileBox___9e6uf","contactBox":"Profile__contactBox___1Xw8H","contactItem":"Profile__contactItem___mF2w3","contactValue":"Profile__contactValue___38tue","contactName":"Profile__contactName___2G2cG","Image":"Profile__Image___14OQf","quoteAuthor":"Profile__quoteAuthor___1rZ86","quote":"Profile__quote___1FM11","profileAbout":"Profile__profileAbout___HHFKW"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Profile/Profile.css
// module id = 31
// module chunks = 0